import { VideoTeaser } from '@/components/VideoTeaser';
import { VideoInTextTeaser } from './VideoInTextTeaser';

export const StandaloneVideoInTextTeaser: typeof VideoTeaser = (props) => <VideoInTextTeaser {...props} />;
